import React, { useState, useEffect, useMemo, useRef } from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { useIntl } from '@leagueplatform/locales';
import { FooterMultiStepProgress } from '../../step-navigation/footerMultiStepProgress';

import { COB_API_TYPE } from '../../../types/online-forms.types';

import useCobStore from '../../../store/cob-store';
import {
  InsuranceDetails,
  PolicyDetails,
  EmploymentStatus,
  SectionDivider,
  MedicareSectionDivider,
  SameInsuranceAs,
  Custody,
  MedicareQuestioner,
} from './index';

import {
  EntitlementReason,
  MedicareCoverage,
  SSNDisability,
  MedicarePartA,
  MedicarePartB,
  MedicarePartC,
  MedicarePartD,
} from '../medicare-insurance-detail/index';

import { FormInstruction } from './form-instruction';

export function OtherQuestioner(props: any) {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'FORM_INSTRUCTIONS_PAGE' }));
  const { hideClose, partnerToken } = props;
  const [isErrorHandling, setErrorHandling] = useState<boolean>(false);
  const [isValidateForm, setIsValidateForm] = useState<boolean>(false);
  const [isValidPCN, setIsValidPCN] = useState<boolean>(false);

  const [isNextDisabled, setIsNextDisabled] = useState<boolean>(false);
  const cobResponse = useCobStore((state: any) => state.cobInformation);
  const dependentsList = useCobStore((state: any) => state.dependents);

  const demographics = useCobStore((state: any) => state.demographics);
  const childRef = useRef<any>();
  const pageCounter = useRef<any>(0);
  const mediCounter = useRef<any>(0);

  const closeCOBForm = () => {
    navigate(-1);
  };

  const checkClose = hideClose === 'false' ? hideClose : 'true';
  // const dependentName = useRef<HTMLInputElement>(null);

  let defaultComponent: JSX.Element[] = [];

  const medicareQuestioner: Array<any> = [
    <MedicareQuestioner
      showFooter="false"
      hideClose
      partnerToken={partnerToken}
    />,
  ];

  const formInstruction: Array<any> = [
    <FormInstruction
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      hideClose={checkClose}
      showFooter="false"
      showContinue="true"
      startValue="0"
    />,
  ];

  let componentList: any = [];

  const setOtherFlowComponent = (
    OtherInsurance: any,
    pageNo: number,
    totalOthers: number,
  ) => {
    const otherSectionComponent = [
      <InsuranceDetails
        OPISResponseInfo={OtherInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        startNow="false"
        pageNo={pageCounter.current + 1}
        totalCount={totalOthers}
        ref={childRef}
      />,
      <PolicyDetails
        OPISResponseInfo={OtherInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageCounter.current + 2}
        totalCount={totalOthers}
      />,
      <EmploymentStatus
        OPISResponseInfo={OtherInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageCounter.current + 3}
        totalCount={totalOthers}
        ref={childRef}
      />,
    ];
    return otherSectionComponent;
  };

  const setMedicareFlowComponent = (
    medicareInsurance: any,
    pageNo: number,
    totalMedicare: number,
  ) => {
    const medicareSectionComponent = [
      <MedicareCoverage
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageNo}
        totalCount={totalMedicare}
        startNow="false"
        ref={childRef}
      />,
      <EntitlementReason
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageNo + 1}
        totalCount={totalMedicare}
        ref={childRef}
      />,
      <SSNDisability
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageNo + 2}
        totalCount={totalMedicare}
        ref={childRef}
      />,
      <MedicarePartA
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageNo + 3}
        totalCount={totalMedicare}
        ref={childRef}
      />,
      <MedicarePartB
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageNo + 4}
        totalCount={totalMedicare}
        ref={childRef}
      />,
      <MedicarePartC
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageNo + 5}
        totalCount={totalMedicare}
        ref={childRef}
      />,
      <MedicarePartD
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        pageNo={pageNo + 6}
        totalCount={totalMedicare}
        ref={childRef}
        partPCNBIN="true"
        isValidPCN={(val: boolean) => setIsValidPCN(val)}
        partnerToken={partnerToken}
      />,
    ];
    return medicareSectionComponent;
  };

  const findContractor = () =>
    cobResponse?.additionalInsurance.find(
      (item: any) =>
        item.member.firstName === demographics?.demographics?.firstName &&
        item.member.dateOfBirth === demographics?.demographics?.dateOfBirth,
      // demographics?.demographics?.relationship === 'Subscriber',
    );

  const checkIsAnyDependentOpted = cobResponse?.additionalInsurance.filter(
    (item: any) => item.hasAdditionalInsurance === 'Y',
  );

  const checkIsAnyDependentOptedMedicare = cobResponse?.medicare.filter(
    (item: any) => item.hasMedicare === 'Y',
  );

  const subscriberOptedMedicare = cobResponse.medicare.filter(
    (cobItem: any) =>
      cobItem.member.firstName === demographics?.demographics?.firstName &&
      cobItem.member.dateOfBirth === demographics?.demographics?.dateOfBirth &&
      cobItem.hasMedicare === 'Y',
  );

  const dependentOptedMedicare =
    demographics?.demographics?.dependents === null
      ? []
      : cobResponse.medicare.filter((cobItem: any) =>
          demographics?.demographics?.dependents.some(
            (profileItem: any) =>
              cobItem.member.firstName === profileItem.firstName &&
              cobItem.member.dateOfBirth === profileItem.dateOfBirth &&
              cobItem.hasMedicare === 'Y',
          ),
        );

  const checkSubscriberMedicare = () =>
    cobResponse?.medicare.filter(
      (item: any) =>
        item.member.firstName === demographics?.demographics?.firstName &&
        item.member.dateOfBirth === demographics?.demographics?.dateOfBirth &&
        item.hasMedicare === 'Y',
    );

  const isSpouse = demographics?.demographics?.dependents?.find(
    (item: any) => item.relationship === 'Spouse',
  );

  const isLogInSpouse = demographics?.demographics?.relationship === 'Spouse';

  const generateMedicare = (
    pageCount: any,
    totalMedicare: any,
    medicareOrderList: any,
  ) => {
    const medicalComponent = [];
    //  const mediCounter = 1;
    mediCounter.current += 1;
    let mediPage = 0;
    for (let i: number = 0; i < medicareOrderList.length; i += 1) {
      mediPage += 1;
      medicalComponent.push(
        ...setMedicareFlowComponent(
          medicareOrderList[i],
          mediPage + 1,
          totalMedicare,
        ),
      );
      mediPage += 7;
      if (i < medicareOrderList.length - 1) {
        medicalComponent.push(
          <MedicareSectionDivider
            showFooter="true"
            errorHandling={() => setErrorHandling(true)}
            name={
              medicareOrderList.length === 1
                ? ''
                : [`${medicareOrderList[i + 1].member.firstName}'s`]
            }
            hideClose={checkClose}
            pageNo={mediPage + 1}
            totalCount={totalMedicare}
          />,
        );
      }
    }
    return medicalComponent;
  };

  const checkEligibility = (checkSpouse: any) => {
    const checkIssubscriber =
      checkIsAnyDependentOpted[0].member.firstname ===
        demographics?.demographics.firstName &&
      demographics?.demographics?.relationship === 'Subscriber';

    return (
      checkSpouse?.firstName !== checkIsAnyDependentOpted[0].member.firstName &&
      !checkIssubscriber
    );
  };

  const checkEligibilityWithMultipleDep = (checkSpouse: any) => {
    const checkhasSpouce = checkIsAnyDependentOpted.filter(
      (item: any) => item.member.name === checkSpouse?.firstName,
    );

    return checkhasSpouce;
  };

  const checkSpouceExist = (checkList: any) => {
    const checkincludedSpouse = checkList.filter(
      (item: any) => item.member.firstName === isSpouse?.firstName,
    );

    return checkincludedSpouse.length > 0;
  };

  const hasDependentsList = useMemo(() => {
    let defaultMedicalComponent = [];
    const pageCount = 0;
    let otherPageCount = 0;
    let totalOtherPage;
    let totalMedicare;
    let custodyControl: any;
    let isSubscriber: boolean;
    const medicarelist = [
      ...subscriberOptedMedicare,
      ...dependentOptedMedicare,
    ];

    if (
      findContractor()?.hasAdditionalInsurance === 'N' &&
      checkIsAnyDependentOpted.length === 1 &&
      checkIsAnyDependentOpted
    ) {
      otherPageCount = 0;
      pageCounter.current = 0;
      totalOtherPage = checkEligibility(isSpouse)
        ? checkIsAnyDependentOpted.length * 3 + checkIsAnyDependentOpted.length
        : checkIsAnyDependentOpted.length * 3;

      // eslint-disable-next-line no-plusplus
      for (let i: number = 0; i < checkIsAnyDependentOpted.length; i += 1) {
        defaultComponent.push(
          ...setOtherFlowComponent(
            checkIsAnyDependentOpted[i],
            pageCounter.current,
            totalOtherPage,
          ),
        );
        otherPageCount += 3;
        isSubscriber =
          checkIsAnyDependentOpted[i].member.firstname ===
            demographics?.demographics.firstName &&
          demographics?.demographics?.relationship === 'Subscriber';
        // eslint-disable-next-line react-hooks/exhaustive-deps
        componentList = [...formInstruction, ...defaultComponent];
        if (
          isSpouse?.firstName !==
            checkIsAnyDependentOpted[0].member.firstName &&
          !isSubscriber
        ) {
          pageCounter.current += 4;
          custodyControl = [
            <Custody
              OPISResponseInfo={checkIsAnyDependentOpted[i]}
              nextButtonClicked={isValidateForm}
              errorHandling={(val: boolean) => setErrorHandling(val)}
              nextDisabled={(val: boolean) => setIsNextDisabled(val)}
              showFooter="true"
              isNextDisabled="true"
              pageNo={pageCounter.current}
              totalCount={totalOtherPage}
              hideClose={checkClose}
            />,
          ];
          componentList.push(...custodyControl);
        }
      }
      if (checkIsAnyDependentOptedMedicare) {
        totalMedicare = medicarelist.length * 7 + medicarelist.length * 1;
        defaultMedicalComponent = generateMedicare(
          pageCount,
          totalMedicare,
          medicarelist,
        );
        const depOptedMedicare = cobResponse?.medicare.filter(
          (item: any) => item.hasMedicare === 'Y',
        );
        componentList.push(
          <MedicareSectionDivider
            showFooter="true"
            errorHandling={() => setErrorHandling(true)}
            name={
              depOptedMedicare.length === 1 &&
              checkSubscriberMedicare().length === 1
                ? ''
                : [`${depOptedMedicare[0]?.member?.firstName}'s`]
            }
            hideClose={checkClose}
            pageNo="1"
            totalCount={totalMedicare}
          />,
          ...defaultMedicalComponent,
        );
      }
    } else if (
      findContractor()?.hasAdditionalInsurance === 'N' &&
      checkIsAnyDependentOpted.length > 1
    ) {
      let noContracterAdditionalInsurance: any = [];
      otherPageCount = 0;
      pageCounter.current = 0;
      let divderSec: Array<any> = [];
      // const contractor =  cobResponse.additionalInsurance.find((item: any) => item.member.firstName === item.subscriber.member.firstName);
      const dependents = cobResponse.additionalInsurance.filter(
        (item: any) => item.hasAdditionalInsurance === 'Y',
      );

      const dependentsOrderList = dependents.sort((a: any, b: any) =>
        a.member.firstName.localeCompare(b.member.firstName),
      );

      noContracterAdditionalInsurance = [...dependentsOrderList];
      let nextOtherDep = 0;
      totalOtherPage = !checkEligibilityWithMultipleDep(isSpouse)
        ? checkIsAnyDependentOpted.length * 4 +
          (checkIsAnyDependentOpted.length - 1) * 2 +
          1
        : checkIsAnyDependentOpted.length * 4 +
          (checkIsAnyDependentOpted.length - 1) * 2 -
          1;

      for (let i = 0; i <= noContracterAdditionalInsurance.length - 1; i += 1) {
        otherPageCount = 0;
        nextOtherDep = i;
        let divderFirstSection: Array<any> = [];
        if (i === 0) {
          defaultComponent.push(
            ...setOtherFlowComponent(
              noContracterAdditionalInsurance[i],
              pageCounter.current,
              totalOtherPage,
            ),
          );

          otherPageCount += 4;
          componentList.push(...formInstruction, ...defaultComponent);
          pageCounter.current += 3;
          isSubscriber =
            noContracterAdditionalInsurance[i].member.firstName ===
              demographics?.demographics.firstName &&
            noContracterAdditionalInsurance[i].member.dateOfBirth ===
              demographics?.demographics.dateOfBirth &&
            demographics?.demographics?.relationship === 'Subscriber';

          if (
            isSpouse?.firstName !==
              noContracterAdditionalInsurance[i].member.firstName &&
            !isSubscriber
          ) {
            pageCounter.current += 1;
            componentList.push(
              <Custody
                OPISResponseInfo={noContracterAdditionalInsurance[i]}
                nextButtonClicked={isValidateForm}
                errorHandling={(val: boolean) => setErrorHandling(val)}
                nextDisabled={(val: boolean) => setIsNextDisabled(val)}
                showFooter="true"
                hideClose={checkClose}
                isNextDisabled="true"
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
              />,
            );
          }

          if (i === 0) {
            pageCounter.current += 1;
            divderFirstSection = [
              <SectionDivider
                showFooter="true"
                hideClose={checkClose}
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
                name={[
                  `${
                    noContracterAdditionalInsurance[i + 1].member.firstName
                  }'s`,
                ]}
              />,
            ];
          }
          componentList.push(...divderFirstSection);
        } else {
          pageCounter.current += 1;
          // eslint-disable-next-line react-hooks/exhaustive-deps
          defaultComponent = [];
          defaultComponent.push(
            ...setOtherFlowComponent(
              noContracterAdditionalInsurance[i],
              pageCounter.current,
              totalOtherPage,
            ),
          );
          otherPageCount +=
            isSpouse?.firstName !==
            noContracterAdditionalInsurance[i].member.firstName
              ? 3
              : 4;

          const sameAsSection = [
            <SameInsuranceAs
              showFooter="true"
              OPISResponseInfo={noContracterAdditionalInsurance[i]}
              errorHandling={() => setErrorHandling(true)}
              firstName={[
                `${noContracterAdditionalInsurance[nextOtherDep].member.firstName}`,
              ]}
              lastName={[
                `${noContracterAdditionalInsurance[nextOtherDep].member.lastName}`,
              ]}
              dateOfBirth={[
                `${noContracterAdditionalInsurance[nextOtherDep].member.dateOfBirth}`,
              ]}
              index={i}
              pageNo={pageCounter.current}
              totalCount={totalOtherPage}
              hideClose={checkClose}
              partnerToken={partnerToken}
            />,
          ];

          isSubscriber =
            noContracterAdditionalInsurance[i].member.firstName ===
              demographics?.demographics.firstName &&
            noContracterAdditionalInsurance[i].member.lastName ===
              demographics?.demographics?.lastName &&
            demographics?.demographics?.relationship === 'Subscriber';

          componentList.push(...sameAsSection, ...defaultComponent);
          pageCounter.current += 3;
          if (
            isSpouse?.firstName !==
              noContracterAdditionalInsurance[i].member.firstName &&
            !isSubscriber
          ) {
            pageCounter.current += 1;
            componentList.push(
              <Custody
                OPISResponseInfo={noContracterAdditionalInsurance[i]}
                nextButtonClicked={isValidateForm}
                errorHandling={(val: boolean) => setErrorHandling(val)}
                nextDisabled={(val: boolean) => setIsNextDisabled(val)}
                showFooter="true"
                isNextDisabled="true"
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
                hideClose={checkClose}
              />,
            );
          }

          if (i < noContracterAdditionalInsurance.length - 1) {
            pageCounter.current += 1;
            divderSec = [
              <SectionDivider
                showFooter="true"
                hideClose={checkClose}
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
                name={[
                  `${
                    noContracterAdditionalInsurance[i + 1].member.firstName
                  }'s`,
                ]}
              />,
            ];
          }
          if (i !== noContracterAdditionalInsurance.length - 1) {
            componentList.push(...divderSec);
          }
        }
      }
      if (dependentOptedMedicare.length >= 1) {
        totalMedicare = medicarelist.length * 7 + medicarelist.length * 1;
        defaultMedicalComponent = generateMedicare(
          pageCount,
          totalMedicare,
          medicarelist,
        );
        componentList.push(
          <MedicareSectionDivider
            showFooter="true"
            errorHandling={() => setErrorHandling(true)}
            name={
              dependentOptedMedicare.length === 1 &&
              checkSubscriberMedicare().length === 1
                ? ''
                : [`${dependentOptedMedicare[0].member.firstName}'s`]
            }
            hideClose={checkClose}
            pageNo="1"
            totalCount={totalMedicare}
          />,
          ...defaultMedicalComponent,
        );
      }
    } else if (
      findContractor()?.hasAdditionalInsurance === 'Y' &&
      checkIsAnyDependentOpted.length === 1
    ) {
      totalOtherPage = checkIsAnyDependentOpted.length * 3;
      isSubscriber =
        cobResponse.additionalInsurance[0].member.firstName ===
          demographics?.demographics.firstName &&
        cobResponse.additionalInsurance[0].member.lastName ===
          demographics?.demographics?.lastName &&
        demographics?.demographics?.relationship === 'Subscriber';

      if (!isLogInSpouse && !isSubscriber) {
        totalOtherPage += 1;
      }
      // eslint-disable-next-line no-plusplus
      for (let i: number = 0; i < checkIsAnyDependentOpted.length; i += 1) {
        defaultComponent.push(
          ...setOtherFlowComponent(
            cobResponse.additionalInsurance[i],
            otherPageCount,
            totalOtherPage,
          ),
        );

        otherPageCount += 3;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        componentList = [...formInstruction, ...defaultComponent];
        if (
          !isLogInSpouse &&
          !isSubscriber &&
          isSpouse?.firstName !==
            cobResponse?.additionalInsurance[i]?.member?.firstName
        ) {
          // pageCounter.current += 4;
          componentList.push(
            <Custody
              OPISResponseInfo={cobResponse.additionalInsurance[i]}
              nextButtonClicked={isValidateForm}
              errorHandling={(val: boolean) => setErrorHandling(val)}
              nextDisabled={(val: boolean) => setIsNextDisabled(val)}
              showFooter="true"
              isNextDisabled="true"
              pageNo={pageCounter.current + 4}
              totalCount={totalOtherPage}
              hideClose={checkClose}
            />,
          );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }

      if (checkIsAnyDependentOptedMedicare.length !== 0) {
        totalMedicare = medicarelist.length * 7 + medicarelist.length * 1;
        defaultMedicalComponent = generateMedicare(
          pageCount,
          totalMedicare,
          medicarelist,
        );
        componentList.push(
          <MedicareSectionDivider
            showFooter="true"
            errorHandling={() => setErrorHandling(true)}
            name={
              // dependentOptedMedicare.length === 1 ||
              checkSubscriberMedicare().length >= 1
                ? ''
                : [`${dependentOptedMedicare[0]?.member?.firstName}'s`]
            }
            hideClose={checkClose}
            pageNo={1}
            totalCount={totalMedicare}
          />,
          ...defaultMedicalComponent,
        );
      }
    } else if (
      findContractor()?.hasAdditionalInsurance === 'Y' &&
      checkIsAnyDependentOpted.length > 1
    ) {
      let finalArray: any = [];
      otherPageCount = 0;
      pageCounter.current = 0;
      let otherDivider: Array<any> = [];
      const contractor = cobResponse.additionalInsurance.find(
        (item: any) =>
          item.member.firstName === demographics.demographics.firstName &&
          item.hasAdditionalInsurance === 'Y',
      );
      const dependents = cobResponse.additionalInsurance
        .filter(
          (item: any) =>
            (item.member.firstName !== demographics.demographics.firstName ||
              item.member.firstName === demographics.demographics.firstName) &&
            item.member.dateOfBirth !== demographics.demographics.dateOfBirth &&
            item.hasAdditionalInsurance === 'Y',
        )
        .sort((a: any, b: any) =>
          a.member.firstName.localeCompare(b.member.firstName),
        );
      finalArray = [contractor, ...dependents];
      // finalArray.push(...dependents);
      // const findPrimaryContractor = finalArray;
      let sameAsSection: Array<any> = [];
      // totalOtherPage = finalArray.length * 6 + finalArray.length * 1 + 2;
      const isSpouseExist = checkSpouceExist(finalArray) ? 5 : 0;
      const subscriberValue = 3;
      totalOtherPage = subscriberValue + isSpouseExist;
      totalOtherPage +=
        checkSpouceExist(finalArray) && isSpouseExist !== 0
          ? (finalArray.length - 2) * 6
          : (finalArray.length - 1) * 6;
      for (let i = 0; i <= finalArray.length - 1; i += 1) {
        // const checkCustody  = checkCustodyOption(cobResponse.additionalInsurance[i]);
        const nextOtherDep = i;
        otherPageCount = 0;
        if (i === 0) {
          defaultComponent.push(
            ...setOtherFlowComponent(
              finalArray[i],
              pageCounter.current,
              totalOtherPage,
            ),
          );
          let divderFirstSec: Array<any> = [];
          otherPageCount += 4;

          componentList = [...formInstruction, ...defaultComponent];
          pageCounter.current += 3;
          isSubscriber =
            finalArray[i].member.firstName ===
              demographics?.demographics.firstName &&
            finalArray[i].member.lastName ===
              demographics?.demographics.lastName &&
            demographics?.demographics?.relationship === 'Subscriber';

          if (!isSubscriber) {
            pageCounter.current += 1;
            componentList.push(
              <Custody
                OPISResponseInfo={finalArray[i]}
                nextButtonClicked={isValidateForm}
                errorHandling={(val: boolean) => setErrorHandling(val)}
                nextDisabled={(val: boolean) => setIsNextDisabled(val)}
                showFooter="true"
                isNextDisabled="true"
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
                hideClose={checkClose}
              />,
            );
          }
          if (nextOtherDep === 0) {
            pageCounter.current += 1;
            divderFirstSec = [
              <SectionDivider
                showFooter="true"
                hideClose={checkClose}
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
                name={[`${finalArray[nextOtherDep + 1]?.member?.firstName}'s`]}
              />,
            ];
          }
          componentList.push(...divderFirstSec);
        } else {
          otherPageCount += 5;
          pageCounter.current += 1;
          // eslint-disable-next-line react-hooks/exhaustive-deps
          defaultComponent = [];
          defaultComponent.push(
            ...setOtherFlowComponent(
              finalArray[i],
              pageCounter.current,
              totalOtherPage,
            ),
          );
          otherPageCount += 4;

          sameAsSection = [
            <SameInsuranceAs
              showFooter="true"
              OPISResponseInfo={finalArray[i]}
              errorHandling={() => setErrorHandling(true)}
              // ref={[`${finalArray[nextOtherDep].member.firstName}`]}
              firstName={[`${finalArray[nextOtherDep].member.firstName}`]}
              lastName={[`${finalArray[nextOtherDep].member.lastName}`]}
              dateOfBirth={[`${finalArray[nextOtherDep].member.dateOfBirth}`]}
              index={i}
              pageNo={pageCounter.current}
              totalCount={totalOtherPage}
              hideClose={checkClose}
              partnerToken={partnerToken}
            />,
          ];
          componentList.push(...sameAsSection, ...defaultComponent);
          pageCounter.current += 3;
          isSubscriber =
            finalArray[i].member.firstname ===
              demographics?.demographics.firstName &&
            finalArray[i].member.lastname ===
              demographics?.demographics.lastName &&
            demographics?.demographics?.relationship === 'Subscriber';

          if (
            isSpouse?.firstName !== finalArray[i].member.firstName &&
            !isSubscriber
          ) {
            pageCounter.current += 1;
            componentList.push(
              <Custody
                OPISResponseInfo={finalArray[i]}
                nextButtonClicked={isValidateForm}
                errorHandling={(val: boolean) => setErrorHandling(val)}
                nextDisabled={(val: boolean) => setIsNextDisabled(val)}
                showFooter="true"
                isNextDisabled="true"
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
                hideClose={checkClose}
              />,
            );
          }

          const nextDependent = i;

          if (nextDependent < finalArray.length - 1) {
            // otherPageCount += 1;
            pageCounter.current += 1;
            otherDivider = [
              <SectionDivider
                showFooter="true"
                hideClose={checkClose}
                pageNo={pageCounter.current}
                totalCount={totalOtherPage}
                name={[`${finalArray[nextDependent + 1].member.firstName}'s`]}
              />,
            ];
          }
          if (i !== finalArray.length - 1) {
            componentList.push(...otherDivider);
          }
        }
      }
      if (
        dependentOptedMedicare.length >= 1 ||
        subscriberOptedMedicare.length >= 1
      ) {
        totalMedicare = medicarelist.length * 7 + medicarelist.length * 1;
        defaultMedicalComponent = generateMedicare(
          pageCount,
          totalMedicare,
          medicarelist,
        );
        componentList.push(
          <MedicareSectionDivider
            showFooter="true"
            errorHandling={() => setErrorHandling(true)}
            name={
              checkSubscriberMedicare().length === 1
                ? ''
                : [`${dependentOptedMedicare[0].member.firstName}'s`]
            }
            hideClose={checkClose}
            pageNo="1"
            totalCount={totalMedicare}
          />,
          ...defaultMedicalComponent,
        );
      }
    } else {
      componentList.push(...medicareQuestioner);
    }
  }, [componentList]);

  useEffect(() => {}, [cobResponse, dependentsList, hasDependentsList]);

  // eslint-disable-next-line no-empty-pattern
  const [] = useState({
    instructionForm: '',
  });

  // }
  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: 'relative', minHeight: '100vh' }}
      data-testid="ot-questioner"
    >
      <FooterMultiStepProgress
        list={componentList}
        handleFormOrNext={isErrorHandling}
        isValidateForm={(val: boolean) => setIsValidateForm(val)}
        closeForm={closeCOBForm}
        formName={COB_API_TYPE.OTHER_INSURANCE}
        isNextDisabled={isNextDisabled}
        isChildRef={childRef}
        isValidPCN={isValidPCN}
        partnerToken={partnerToken}
      />
    </StackLayout>
  );
}
